<template>
  <LoadingWrapper :loading="!data">
    <template #loading>
      <span class="width-percent-100 flex-start margin-bottom-12">
        <b-skeleton
          class="width-32 height-28 border-radius-4 margin-left-8"
        ></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </span>
    </template>
    <template #default>
      <ProfileBoxPopupWrapper
        :data="userItem"
        :deskTopPopupClass="deskTopPopupClass"
        nameClass="color-complementary cursor--pointer"
        :disabled="!hasProfilePopup"
      >
        <div class="flex-start">
          <ul class="margin-0 padding-0 flex list-style--none min-width-40">
            <li
              v-for="(image, index) in avatarImages"
              :key="`avatar-${index}`"
              class="border--solid border--surface border--width-2 border-radius-8 max-width-16"
            >
              <ImageBox
                :src="image"
                :imageClass="`width-${generateAvatarSize} height-${generateAvatarSize} border-radius-8 background-light-gray`"
                :defaultImage="defaultImage"
                :loadingClass="`right-2 top-2 width-${generateAvatarSize} height-${generateAvatarSize} border-radius-8`"
              />
            </li>
          </ul>
          <span
            :class="`font-size-12 color-complementary-300 margin-right-${generateCaptionMargin}`"
          >
            {{ name }} <span v-if="hasType">({{ type }})</span>
            <span class="color-complementary-100 margin-x-4"> | </span>
            <span class="font-size-12 color-complementary-300">
              <CopyTextWrapper
                :text="code"
                textClass="color-complementary-200 cursor--pointer"
              />
            </span>
            <component :is="secondCaptionTag" v-if="secondCaption">
              <span
                v-html="secondCaption"
                class="color-complementary-300 font-size-12 cursor--pointer"
              />
            </component>
          </span>
        </div>
      </ProfileBoxPopupWrapper>
    </template>
  </LoadingWrapper>
</template>

<script>
import { LoadingWrapper } from "@/components/re-design";
import ProfileBoxPopupWrapper from "../profile-box/ProfileBoxPopupWrapper.vue";
import CopyTextWrapper from "../copy-text-wrapper/CopyTextWrapper.vue";
import { generateConfig, goToRoute } from "@/shared/utils";
import { computed, toRefs } from "vue";
import { pathOr } from "ramda";
import ImageBox from "../image-box/ImageBox.vue";
export default {
  components: {
    LoadingWrapper,
    ProfileBoxPopupWrapper,
    CopyTextWrapper,
    ImageBox,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    userItem: {
      type: Object,
      default: null,
    },
    hasType: {
      type: Boolean,
      default: true,
    },
    hasProfilePopup: {
      type: Boolean,
      default: true,
    },
    singleAvatarSize: {
      type: [String, Number],
      default: 32,
    },
    singleAvatarCaptionMargin: {
      type: [String, Number],
      default: 8,
    },
    defaultImagePadding: {
      type: [String, Number],
      default: 4,
    },
    secondCaptionTag: {
      type: String,
      default: "div",
    },
    deskTopPopupClass: {
      type: String,
      default: "top-230",
    },
  },
  setup(props) {
    // generate props data
    const { data, avatarSize, singleAvatarSize, singleAvatarCaptionMargin } =
      toRefs(props);

    const defaultImage = generateConfig([
      "images",
      "shared",
      "redesign",
      "empty",
      "noUser",
    ]);
    const avatarImages = computed(() => {
      return pathOr([], ["images"], data.value);
    });
    const name = computed(() => pathOr("", ["name"], data.value));
    const type = computed(() => pathOr("", ["type"], data.value));
    const code = computed(() => pathOr("", ["id"], data.value));
    const personCode = computed(() => pathOr(null, ["personCode"], data.value));
    const secondCaption = computed(() =>
      pathOr(null, ["secondCaption"], data.value)
    );

    const generateAvatarSize = computed(() =>
      avatarImages.value.length > 1 ? 24 : singleAvatarSize.value
    );
    const generateCaptionMargin = computed(() =>
      avatarImages.value.length > 1 ? 8 : singleAvatarCaptionMargin.value
    );

    const goToPersonProfile = () => {
      if (!personCode.value) return;
      goToRoute("editPerson", { code: personCode.value });
    };

    // return data to be used in template
    return {
      data,
      avatarSize,
      defaultImage,
      generateAvatarSize,
      generateCaptionMargin,
      avatarImages,
      name,
      type,
      code,
      personCode,
      secondCaption,
      goToPersonProfile,
    };
  },
};
</script>
